export default __webpack_public_path__ + "43ec59ab9e36d30c5e218f1eecbd2df5.png";